<template>
    <v-data-table
        dense
        disable-pagination
        disable-sort
        hide-default-footer
        :headers="headers"
        :items="data">
        <template v-slot:[`item.amount`]="{item}">
            <span class="font-weight-bold">{{item.currency}}</span> {{formatNumber(item.amount, 2)}}
        </template>
        <template v-slot:[`item.base_amount`]="{item}">
            <span class="font-weight-bold">{{baseCurrency.abbreviation}}</span> {{formatNumber(item.base_amount, 2)}}
        </template>
        <template v-slot:[`foot`]="{}">
            <tfoot class="font-weight-bold">
                <tr class="secondary">
                    <td colspan="5">Totals</td>
                    <td><span >{{baseCurrency.abbreviation}}</span> {{formatNumber(getTotal(data, "base_amount"), 2)}}</td>
                </tr>
            </tfoot>
        </template>
    </v-data-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { formatNumber } from 'accounting';
import { getTotal } from './../../utils/accounting';

export default {
    name: "PaymentDetailsReportTable",
    data() {
        return {
            headers: [
                { text: "Date", value: "date" },
                { text: "Mode", value: "mode" },
                { text: "Customer", value: "customer" },
                { text: "Amount", value: "amount" },
                { text: "Currency", value: "currency" },
                { text: "Amount", value: "base_amount" }
            ]
        }
    },
    computed: {
        ...mapGetters("sales/reports/paymentDetails", ["data"]),
        ...mapState("accounting", ["baseCurrency"])
    },
    methods: {
        formatNumber,
        getTotal
    }
}
</script>

<style>

</style>